import React from "react";
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const CounterItem = ({ countNum, countTitle }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1
    });

    return (
        <div className="counterup_style--1 col-lg-4 col-md-4 col-sm-6 col-12" ref={ref}>
            <h5 className="counter">
                <CountUp end={inView ? countNum : 0} />
            </h5>
            <p className="description">{countTitle}</p>
        </div>
    );
};

const CounterOne = () => {
    const Data = [
        {
            countNum : 80,
            countTitle: 'video themes to choose from. Fireplaces, Ocean Waves, Thunderstorms, Coral Reefs, ...',
        },
        {
            countNum : 1450,
            countTitle: 'unique ambient videos to choose from. Videos loop seamlessly, and come with nature sound and/or music.',
        },
        {
            countNum : 17400,
            countTitle: 'hours total playtime. To view all our videos it`d take you way more than a year continuously watching',
        },
    ];

    return(
        <div className="row">
            {Data.map((value, index) => (
                <CounterItem
                    key={index}
                    countNum={value.countNum}
                    countTitle={value.countTitle}
                />
            ))}
        </div>
    )
}

export default CounterOne;